import React, { useCallback, useContext, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconButton, Menu } from '@mui/material';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import {
    DossierActionContext,
    REFRESH_CURRENT_DOSSIER_CTX,
    useCurrentDossierCtxDispatch,
    useDossierActionMenuItems,
} from '@europrocurement/l2d-modules';

export type ActionMenuProps = {
    dossier: DossierOpenSearch;
};

const ActionMenu: React.FunctionComponent<ActionMenuProps> = function (props) {
    const { dossier } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { triggerAction } = useContext(DossierActionContext);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const dispatch = useCurrentDossierCtxDispatch();
    const refreshDossier = useCallback(() => {
        if (dispatch) {
            dispatch({ type: REFRESH_CURRENT_DOSSIER_CTX });
        }
    }, [dispatch]);

    const { dossierActionMenuItemsBack } = useDossierActionMenuItems({
        dossier,
        triggerAction,
        setAnchorEl,
        refreshDossier,
    });

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis-vertical']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {dossierActionMenuItemsBack.map((menuItem) => menuItem)}
            </Menu>
        </div>
    );
};

export default ActionMenu;
